import { createSelector } from '@reduxjs/toolkit';

import type { RootState } from '@/store/root-reducer';

import { validateDraft } from '../domain/licence-draft.validation';

const selectAddLicence = (state: RootState) => state.addLicence;

export const selectDraft = (state: RootState) => selectAddLicence(state).draft;
export const selectSaveStatus = (state: RootState) => selectAddLicence(state).saveStatus;
export const selectError = (state: RootState) => selectAddLicence(state).error;
export const selectCreatedLicenceId = (state: RootState) =>
  selectAddLicence(state).createdLicenceId;
export const selectValidationErrors = (state: RootState) =>
  selectAddLicence(state).validationErrors;
export const selectIsSaving = (state: RootState) =>
  selectAddLicence(state).saveStatus === 'saving';
export const selectNameAvailability = (state: RootState) =>
  selectAddLicence(state).nameAvailability;
export const selectIsNameTaken = (state: RootState) =>
  selectAddLicence(state).nameAvailability === 'taken';
export const selectCsmCandidates = (state: RootState) => selectAddLicence(state).csmCandidates;
export const selectClientCategories = (state: RootState) =>
  selectAddLicence(state).clientCategories;

/** Derived: is the current draft valid? Memoised on the draft reference. */
export const selectIsDraftValid = createSelector(
  selectDraft,
  (draft) => Object.keys(validateDraft(draft)).length === 0,
);
